import { useMemo } from 'react';

export default function useIdempotencyKeyGenerator() {
  const idempotencyKey = useMemo(() => crypto.randomUUID(), []);
  return idempotencyKey;
}
